export default "__VITE_ASSET__DCbOgGsi__"